import {STATE} from '../symbols';
import {getHostVariables} from '../utils';
import {wrapDispatch} from './utils';
import createContextProxy from '../context/createContextProxy';

export function createContext(host, action) {
	const properties = host.getResolvedProperties();
	const hostVariables = getHostVariables(host);

	return {
		coeffects: {
			state: {...hostVariables[STATE], properties: host.getProperties()},
			context: createContextProxy(host),
			properties,
			host,
			action,
			...wrapDispatch(host, action)
		},
		effects: []
	};
}
